"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParsingResult = exports.ParsingComponents = void 0;

var quarterOfYear_1 = __importDefault(require("dayjs/plugin/quarterOfYear"));

var dayjs_1 = __importDefault(require("dayjs"));

dayjs_1.default.extend(quarterOfYear_1.default);

var ParsingComponents = /*#__PURE__*/function () {
  function ParsingComponents(refDate, knownComponents) {
    _classCallCheck(this, ParsingComponents);

    this.knownValues = {};
    this.impliedValues = {};

    if (knownComponents) {
      for (var key in knownComponents) {
        this.knownValues[key] = knownComponents[key];
      }
    }

    var refDayJs = dayjs_1.default(refDate);
    this.imply("day", refDayJs.date());
    this.imply("month", refDayJs.month() + 1);
    this.imply("year", refDayJs.year());
    this.imply("hour", 12);
    this.imply("minute", 0);
    this.imply("second", 0);
    this.imply("millisecond", 0);
  }

  _createClass(ParsingComponents, [{
    key: "get",
    value: function get(component) {
      if (component in this.knownValues) {
        return this.knownValues[component];
      }

      if (component in this.impliedValues) {
        return this.impliedValues[component];
      }

      return null;
    }
  }, {
    key: "date",
    value: function date() {
      return this.dayjs().toDate();
    }
  }, {
    key: "isCertain",
    value: function isCertain(component) {
      return component in this.knownValues;
    }
  }, {
    key: "getCertainComponents",
    value: function getCertainComponents() {
      return Object.keys(this.knownValues);
    }
  }, {
    key: "imply",
    value: function imply(component, value) {
      if (component in this.knownValues) {
        return this;
      }

      this.impliedValues[component] = value;
      return this;
    }
  }, {
    key: "assign",
    value: function assign(component, value) {
      this.knownValues[component] = value;
      delete this.impliedValues[component];
      return this;
    }
  }, {
    key: "delete",
    value: function _delete(component) {
      delete this.knownValues[component];
      delete this.impliedValues[component];
    }
  }, {
    key: "clone",
    value: function clone() {
      var component = new ParsingComponents(new Date());
      component.knownValues = {};
      component.impliedValues = {};

      for (var key in this.knownValues) {
        component.knownValues[key] = this.knownValues[key];
      }

      for (var _key in this.impliedValues) {
        component.impliedValues[_key] = this.impliedValues[_key];
      }

      return component;
    }
  }, {
    key: "isOnlyDate",
    value: function isOnlyDate() {
      return !this.isCertain("hour") && !this.isCertain("minute") && !this.isCertain("second");
    }
  }, {
    key: "isOnlyTime",
    value: function isOnlyTime() {
      return !this.isCertain("weekday") && !this.isCertain("day") && !this.isCertain("month");
    }
  }, {
    key: "isOnlyWeekdayComponent",
    value: function isOnlyWeekdayComponent() {
      return this.isCertain("weekday") && !this.isCertain("day") && !this.isCertain("month");
    }
  }, {
    key: "isOnlyDayMonthComponent",
    value: function isOnlyDayMonthComponent() {
      return this.isCertain("day") && this.isCertain("month") && !this.isCertain("year");
    }
  }, {
    key: "isValidDate",
    value: function isValidDate() {
      var dateMoment = this.dayjs();

      if (this.isCertain("timezoneOffset")) {
        var adjustTimezoneOffset = this.get("timezoneOffset") - dateMoment.utcOffset();
        dateMoment = dateMoment.add(adjustTimezoneOffset, "minute");
      }

      if (dateMoment.get("year") != this.get("year")) return false;
      if (dateMoment.get("month") != this.get("month") - 1) return false;
      if (dateMoment.get("date") != this.get("day")) return false;
      if (this.get("hour") != null && dateMoment.get("hour") != this.get("hour")) return false;
      if (this.get("minute") != null && dateMoment.get("minute") != this.get("minute")) return false;
      return true;
    }
  }, {
    key: "dayjs",
    value: function dayjs() {
      var result = dayjs_1.default();
      result = result.year(this.get("year"));
      result = result.month(this.get("month") - 1);
      result = result.date(this.get("day"));
      result = result.hour(this.get("hour"));
      result = result.minute(this.get("minute"));
      result = result.second(this.get("second"));
      result = result.millisecond(this.get("millisecond"));
      var currentTimezoneOffset = result.utcOffset();
      var targetTimezoneOffset = this.get("timezoneOffset") !== null ? this.get("timezoneOffset") : currentTimezoneOffset;
      var adjustTimezoneOffset = targetTimezoneOffset - currentTimezoneOffset;
      result = result.add(-adjustTimezoneOffset, "minute");
      return result;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[ParsingComponents {knownValues: ".concat(JSON.stringify(this.knownValues), ", impliedValues: ").concat(JSON.stringify(this.impliedValues), "}]");
    }
  }], [{
    key: "createRelativeFromRefDate",
    value: function createRelativeFromRefDate(refDate, fragments) {
      var date = dayjs_1.default(refDate);

      for (var key in fragments) {
        date = date.add(fragments[key], key);
      }

      var components = new ParsingComponents(refDate);

      if (fragments["hour"] || fragments["minute"] || fragments["second"]) {
        components.assign("hour", date.hour());
        components.assign("minute", date.minute());
        components.assign("second", date.second());
        components.assign("timezoneOffset", date.utcOffset());
        components.assign("day", date.date());
        components.assign("month", date.month() + 1);
        components.assign("year", date.year());
      } else {
        components.imply("hour", date.hour());
        components.imply("minute", date.minute());
        components.imply("second", date.second());
        components.imply("timezoneOffset", date.utcOffset());

        if (fragments["d"]) {
          components.assign("day", date.date());
          components.assign("month", date.month() + 1);
          components.assign("year", date.year());
        } else {
          if (fragments["week"]) {
            components.imply("weekday", date.day());
          }

          components.imply("day", date.date());

          if (fragments["month"]) {
            components.assign("month", date.month() + 1);
            components.assign("year", date.year());
          } else {
            components.imply("month", date.month() + 1);

            if (fragments["year"]) {
              components.assign("year", date.year());
            } else {
              components.imply("year", date.year());
            }
          }
        }
      }

      return components;
    }
  }]);

  return ParsingComponents;
}();

exports.ParsingComponents = ParsingComponents;

var ParsingResult = /*#__PURE__*/function () {
  function ParsingResult(refDate, index, text, start, end) {
    _classCallCheck(this, ParsingResult);

    this.refDate = refDate;
    this.index = index;
    this.text = text;
    this.start = start || new ParsingComponents(this.refDate);
    this.end = end;
  }

  _createClass(ParsingResult, [{
    key: "clone",
    value: function clone() {
      var result = new ParsingResult(this.refDate, this.index, this.text);
      result.start = this.start ? this.start.clone() : null;
      result.end = this.end ? this.end.clone() : null;
      return result;
    }
  }, {
    key: "date",
    value: function date() {
      return this.start.date();
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[ParsingResult {index: ".concat(this.index, ", text: '").concat(this.text, "', ...}]");
    }
  }]);

  return ParsingResult;
}();

exports.ParsingResult = ParsingResult;